import React from "react";
import { useToggle } from "usehooks-ts";
import cx from "classnames";
import SectionControl from "pages/Profile/components/SectionControl";
import ProfileHeader from "pages/Profile/components/ProfileHeader";
import Gallery from "pages/Profile/components/GalerySection";
import RepsSection from "pages/Profile/components/RepsSection";
import TalentSpecsSection from "pages/Profile/components/TalentSpecsSection";
import SkillsSection from "pages/Profile/components/SkillsSection";
import TrainingSection from "pages/Profile/components/TrainingSection";
import CreditsSection from "pages/Profile/components/CreditsSection";
import SocialMediaSection from "pages/Profile/components/SocialMediaSection";
import MediaSection from "pages/Profile/components/MediaSection";
import Footer from "pages/Profile/components/Footer";
import "pages/Profile/styles.scss";

const Profile = () => {
  const [headExpanded, headToggle, setHeadValue] = useToggle();
  const [bodyExpanded, toggleBody, setBodyValue] = useToggle();
  const [isEdit, toggleEdit] = useToggle();

  const expandHeadToggle = () => {
    headToggle();
    setBodyValue(false);
  };

  const expandBodyToggle = () => {
    toggleBody();
    setHeadValue(false);
  };

  return (
    <div className="profile-page">
      <div className="profile-page-container">
        <ProfileHeader isEdit={isEdit} toggleEdit={toggleEdit} />
        <div
          className={cx("profile-page-grid", {
            "head-expanded": headExpanded === true,
            "body-expanded": bodyExpanded === true,
          })}
        >
          <div className="grid-item--head">
            <Gallery
              isHeadExpanded={headExpanded}
              toggleHeadExpanded={expandHeadToggle}
              isEdit={isEdit}
            />
            <RepsSection isEdit={isEdit} />
            <SocialMediaSection />
            <TalentSpecsSection isEdit={isEdit} />
          </div>
          <div className="grid-item--body relative">
            <SectionControl
              isExpanded={bodyExpanded}
              toggleClick={expandBodyToggle}
              fullScreenClick={() => undefined}
              className="right-3 top-3"
            />
            <MediaSection isEdit={isEdit} />
            <CreditsSection isEdit={isEdit} />
          </div>
          <div className="grid-item--tail">
            <SkillsSection isEdit={isEdit} />
            <TrainingSection isEdit={isEdit} />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Profile;
